'use client';

import { CTAButtons } from '@components/ctaButtons';

import { TranslatedComponent } from '@/shared/types';

export const PageTitleButtonBlock = ({ translations }: TranslatedComponent) => {
  return (
    <div className="flex w-full flex-wrap items-center gap-4">
      <CTAButtons
        mainButton={{
          label: translations.buttonGetConsultation,
          spacing: 'normal',
        }}
        secondaryButton={{
          analyticsEvent: 'begin_free',
          target: '_blank',
          href: translations.startFreeLink,
          label: translations.getDemoKey,
          spacing: 'normal',
        }}
      />
    </div>
  );
};
